var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Badge',{attrs:{"text":_vm.text,"type":_vm.type,"class-name":"badge-msg"}})}
var staticRenderFns = []

export { render, staticRenderFns }